<template>
<!-- 定制化表单页面 -->
    <div class="customFormWrapper">
        <!-- 通用搜索筛选表格 -->
        <el-card class="box-card"
                 v-if="filterFormList.indexOf(nodeCodeCopy) > -1 || extractingList.indexOf(nodeCodeCopy) > -1">
            <div slot="header" class="clearfix">
                <span>{{nodeTitleCopy}}</span>
            </div>
            <template>
                <el-form ref="form" class="form" :model="form" :inline="true" label-width="85px">
                    <el-form-item label="投标单位："
                                  style="width: auto"
                                  v-if="filterFormList.indexOf(nodeCodeCopy) > -1"
                                  props="keywords">
                        <el-input v-model.trim="form.keywords" clearable placeholder="请输入内容搜索" @keyup.enter.native="getCustomData"></el-input>
                    </el-form-item>
                    <el-form-item label="缴纳状态：" style="width: auto" v-if="nodeCodeCopy == 'GC00017'">
                        <el-select  v-model="form.state" @change="getCustomData">
                            <el-option label="全部" value="99"></el-option>
                            <el-option label="未缴纳" value="0"></el-option>
                            <el-option label="已缴纳" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="抽取人："  style="width: 40%;float: left" v-if="extractingList.indexOf(nodeCodeCopy) > -1">
                        <span class="activeColor">{{customFormData.extractorName || '-'}}</span>
                    </el-form-item>
                    <el-form-item label="抽取时间：" style="width: 40%;float: right" v-if="extractingList.indexOf(nodeCodeCopy) > -1">
                        <span class="activeColor">{{customFormData.extractTime || '-'}}</span>
                    </el-form-item>
                    <el-button size="small" type="primary" v-if="filterFormList.indexOf(nodeCodeCopy) > -1" @click="getCustomData">搜索</el-button>
                </el-form>
                <el-table
                        :data="tableData"
                        v-loading="dataListLoading"
                        border
                        style="width: 100%">
                    <el-table-column fixed
                                     label="序号"
                                     type="index"
                                     :index="indexMethod" width="120" align="center"></el-table-column>
                    <el-table-column
                            v-for="(item,index) in nodeCodeMapper[nodeCodeCopy].column"
                            :key="index"
                            align="center"
                            :prop="item.prop"
                            :label="item.label"
                            :width="item.width">
                    </el-table-column>
                </el-table>
                <el-pagination background
                               layout="sizes, prev, pager, next"
                               :page-sizes="[pageSize, 20, 50, 100]"
                               :page-size="pageSize"
                               :total="total"
                               :current-page="pageIndex"
                               @size-change="sizeChangeHandle"
                               @current-change="currentChangeHandle"></el-pagination>
            </template>
        </el-card>
        <!--招标文件及公告 -->
		<fileNotice
			v-if="fileNoticeList.indexOf(nodeCodeCopy) > -1"
      		:businessType="nodeCodeMapper[nodeCodeCopy].businessType"
			ref="fileNoticeRef"
			:title.sync="nodeCodeMapper[nodeCodeCopy].title"
			:dataListLoading.sync="dataListLoading"
			:hisListData.sync="tableData"
			:categoryCode.sync="categoryCode"
			:categoryIsOpen.sync="paramMap.categoryIsOpen"
			:nodeCode="nodeCodeCopy">
		</fileNotice>
        <!-- 评委要求澄清与答复记录-->
        <clarificationAndReply
                v-if="clarificationAndReplyList.indexOf(nodeCodeCopy) > -1"
                :title.sync="nodeTitle"
                :dataListLoading.sync="dataListLoading"
                :tableData.sync="tableData"
                :total.sync="total"
                @queryCustomFormData="getCustomDataFn">
        </clarificationAndReply>
        <!--         异议与答复-->
        <objectionAndReply
                v-if="objectionAndReplyList.indexOf(nodeCodeCopy) > -1"
                :title.sync="nodeTitle"
                :dataListLoading.sync="dataListLoading"
                :tableData.sync="tableData"
                :total.sync="total"
                @queryCustomFormData="getCustomDataFn">
        </objectionAndReply>
        <!--         依法讯问-->
        <askAndReply
                v-if="askAndReplyList.indexOf(nodeCodeCopy) > -1"
                :title.sync="nodeTitle"
                :dataListLoading.sync="dataListLoading"
                :projectInfo="purchaseProjectInfo"
                :tableData.sync="tableData"
                :total.sync="total"
                @queryCustomFormData="getCustomDataFn">
        </askAndReply>
        <!--         开标参与人员登记 -->
        <openBidParticipant
                v-if="openBidParticipantList.indexOf(nodeCodeCopy) > -1"
                ref="openBidParticipantRef"
                :title.sync="nodeTitle"
                :dataListLoading.sync="dataListLoading"
                :hisListData.sync="tableData"
                :categoryCode.sync="categoryCode"
                :categoryIsOpen.sync="paramMap.categoryIsOpen"
                :nodeCode="nodeCodeCopy">
        </openBidParticipant>
        <!--         质疑管理-->
        <quesManageList
                v-if="quesManageListD.indexOf(nodeCodeCopy) > -1"
                :title.sync="nodeTitle"
                :dataListLoading.sync="dataListLoading"
                :projectInfo="purchaseProjectInfo"
                :tableData.sync="tableData"
                :total.sync="total"
                @queryCustomFormData="getCustomDataFn">
        </quesManageList>
        <!--         评委打分情况 或 招标人代表打分情况 或 采购评委打分列表-->
        <scoreTable
                v-if="scoreTableList.indexOf(nodeCodeCopy) > -1"
                ref="scoreTableRef"
                :nodeCode="nodeCodeCopy"
                :treeData.sync="treeData"
                :professorList.sync="professorList"
                :title.sync="nodeTitle"
                :dataListLoading.sync="dataListLoading"
                :tableData.sync="scoreTableData"
                :getScoreListParams.sync="getScoreListParams"
                @queryCustomFormData="getScoreListFn">
        </scoreTable>
        <!--  采购项目-->
        <purchaseProject
                v-if="purchaseProjectList.indexOf(nodeCodeCopy) > -1"
                :dataListLoading.sync="dataListLoading"
                :tableData.sync="tableData"
                :projectInfo="purchaseProjectInfo"
                :total.sync="total"
                @queryCustomFormData="getCustomDataFn">
        </purchaseProject>

        <!--		专家信息抽取申请-->
        <expertExtraction  v-if="expertExtractionList.indexOf(nodeCodeCopy) > -1"
                           ref="expertExtractions"
                           :nodeCode.sync='nodeCodeCopy'
                           :projectInfo="purchaseProjectInfo"
                           @queryCustomFormData="getExpertExtractionFn">

        </expertExtraction>

        <!--  项目归档-->
        <tenderSummaryCatalog v-if="tenderSummaryCatalogList.indexOf(nodeCodeCopy) > -1"
                              ref="tenderSummaryCatalog"
                              :nodeCode.sync='nodeCodeCopy'
                              :projectInfo="purchaseProjectInfo"
                              @queryCustomFormData="getCatalogFn"></tenderSummaryCatalog>

        <!-- 附件数据 -->
        <el-card class="box-card" v-if="showAttachmentList.indexOf(nodeCodeCopy) > -1">
            <div slot="header" class="clearfix">
                <span>附件列表</span>
            </div>
            <template>
                <div id="affixDown" v-if="attachmentList.length > 0">
                    <affix-doc v-for="(item,index) in attachmentList"
                               :item.sync="item"
                               :index="index"
                               :key="index"
                               @updateItem="updateItem"
                               :name="item.titleName">
                    </affix-doc>
                </div>
                <p style="text-align: center" v-if="attachmentList.length == 0">暂无附件数据</p>
            </template>
        </el-card>

        <el-card calss="box-card" v-if="!(nodeCodeMapper[nodeCodeCopy] && nodeCodeMapper[nodeCodeCopy].title)"  style="margin-bottom: 10px">
            <p style="text-align: center">暂无表单数据</p>
        </el-card>

        <el-card class="box-card" style="margin-bottom:10px" v-if="auditHisTableCopy.length > 0">
            <div slot="header" class="clearfix">
                <span>见证记录</span>
            </div>
            <el-table
                    :data="auditHisTableCopy"
                    border
                    style="width: 100%;">
                <el-table-column
                        type="index"
                        :index="indexMethod"
                        header-align="center"
                        align="center"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="auditName"
                        align="center"
                        width="180"
                        label="见证人"  >
                </el-table-column>
                <el-table-column
                        prop="auditTime"
                        align="center"
                        width="180"
                        label="见证时间">
                </el-table-column>
                <el-table-column
                        prop="auditOpinion"
                        align="center"
                        label="见证意见">
                </el-table-column>
            </el-table>
        </el-card>

    </div>
</template>

<script>

    import fileNotice from './fileNotice';
    import clarificationAndReply from './clarificationAndReply';
    import objectionAndReply from './objectionAndReply';
    import askAndReply from './askAndReply';
    import openBidParticipant from './openBidParticipant';
    import tenderSummaryCatalog from './tenderSummaryCatalog';
    import quesManageList from './quesManageList';
    import scoreTable from './scoreTable';
    import purchaseProject from './purchaseProject';
    import affixDoc from '@/components/affixDoc';
    import expertExtraction from './expertExtraction';
    import $ from "jquery";

    export default {
        components: {
            fileNotice,
            clarificationAndReply,
            objectionAndReply,
            askAndReply,
            openBidParticipant,
            quesManageList,
            scoreTable,
            purchaseProject,
            affixDoc,
            expertExtraction,
            tenderSummaryCatalog
        },
        props:{
            nodeCode:{
                type:String,
                defalut:'GC00014'
            },
            nodeTitle:{
                type:String,
                defalut:''
            },
            auditHisTable:{
                type:Array,
                default:()=>([])
            },
            entityId:{
                type:String,
                default:""
            },
            categoryCode:{
                type:String,
                default:""
            },
            projectCode:{
                type:String,
                default:""
            },
        },
        computed:{
            nodeTitleCopy: {
                get() {
                    return  this.nodeTitle || this.nodeCodeMapper[this.nodeCodeCopy].title
                }
            }
        },
        watch:{
            nodeTitle:{
                immediate: true,
                handler (val) {
                    this.nodeTitle = val
                },
                deep: true
            },
            nodeCode:{
                immediate: true,
                handler (val) {
                    this.nodeCodeCopy = val
                },
                deep: true
            },
            auditHisTable: {
                immediate: true,
                handler (val) {
                    this.auditHisTableCopy = val
                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },
        },
        data() {
            return {

                nodeCodeMapper:{
                    'GC00014':{
                        title:'资审文件下载情况', // dataType (1资审文件 2招标文件) tenderProjectCode bidSectionCode keywords
                        path:'nonCustomForm/getFileDownload',
                        queryMethod:'get',
                        column:[{label:"投标单位",prop:"applyName",width:''},{label:"下载时间",prop:"downloadTime",width:'160'},{label:"备注",prop:"remark",width:''}],
                    },
                    'GC00015':{
                        title:'招标文件下载情况', // dataType (1资审文件 2招标文件) tenderProjectCode bidSectionCode keywords
                        path:'/nonCustomForm/getFileDownload',
                        queryMethod:'get',
                        column:[{label:"投标单位",prop:"applyName",width:''},{label:"首次下载时间",prop:"downloadTime",width:'160'}],
                    },
                    'GC00034':{
                        title:'资审申请文件递交情况', // dataType (1资审申请文件 2标书)  tenderProjectCode bidSectionCode keywords
                        path:'/nonCustomForm/getFileRefer',
                        queryMethod:'get',
                        column:[{label:"投标单位",prop:"applyName",width:''},{label:"状态",prop:"stateName",width:'100'},{label:"递交时间",prop:"referTime",width:'160'},{label:"撤回时间",prop:"backTime",width:'160'}],
                    },
                    'GC00016':{
                        title:'标书递交情况', // dataType (1资审申请文件 2标书)  tenderProjectCode bidSectionCode keywords
                        path:'/nonCustomForm/getFileRefer',
                        queryMethod:'get',
                        column:[{label:"投标单位",prop:"applyName",width:''},{label:"状态",prop:"stateName",width:''},{label:"递交时间",prop:"referTime",width:'160'},{label:"撤回时间",prop:"backTime",width:'160'}],
                    },
                    'GC00017':{
                        title:'保证金缴纳情况', // dataType=0  tenderProjectCode bidSectionCode keywords
                        path:'/nonCustomForm/getMarginPayrecords',
                        queryMethod:'get',
                        column:[{label:"投标单位",prop:"applyName",width:''},{label:"缴纳状态",prop:"stateName",width:'100'},{label:"缴纳金额",prop:"amount",width:'180'},{label:"缴纳时间",prop:"payTime",width:'160'}],
                    },
                    'GC00018':{
                        title:'参数抽取情况', // tenderProjectCode bidSectionCode
                        path:'/nonCustomForm/getParamExtractRecord',
                        queryMethod:'get',
                        column:[{label:"参数名",prop:"paraName",width:''},{label:"描述/说明",prop:"paraDesc",width:''},{label:"值",prop:"paraValue",width:''}],
                    },
                    'GC00022':{
                        title:'评委要求澄清与答复记录', // tenderProjectCode bidSectionCode
                        queryMethod:'get',
                        path:'/nonCustomForm/listEvalClarifys'
                    },
                    'GC00030':{
                        title:'异议与答复', // tenderProjectCode bidSectionCode keywords
                        queryMethod:'get',
                        path:'/nonCustomForm/listObjectReplys'
                    },
                    'GC00023':{
                        title:'评委打分情况', // tenderProjectCode bidSectionCode
                        queryMethod:'get',
                        path:'/nonCustomForm/listGcEvalScores'
                    },
                    'GC00036':{
                      title:'招标人代表打分情况', // tenderProjectCode bidSectionCode
                        queryMethod:'get',
                      path:'/nonCustomForm/listGcEvalScores'
                    },
                    'CG00001':{
                        title:'采购项目', // purchaseProjectCode purchaseSectionCode
                        queryMethod:'get',
                        path:'/cg/nonCustomForm/getCgProjectInfo'
                    },
                    'CG00027':{
                        title:'评委要求澄清与答复记录', // purchaseProjectCode purchaseSectionCode  applyCode pageIndex pageSize
                        queryMethod:'get',
                        path:'/cg/nonCustomForm/listEvalClarifys'
                    },
                    'CG00028':{
                        title:'评委打分情况', // purchaseProjectCode purchaseSectionCode  idcard type pageSize
                        queryMethod:'get',
                        path:'/cg/nonCustomForm/listCgEvalScores'
                    },
                    'CG00036':{
                        title:'依法询问', // purchaseProjectCode purchaseSectionCode  idcard type pageSize
                        queryMethod:'get',
                        path:'/cg/nonCustomForm/getCgTenderConsult'
                    },
                    'CG00037':{
                        title:'质疑管理', // purchaseProjectCode purchaseSectionCode
                        queryMethod:'get',
                        path:'/cg/nonCustomForm/getTenderQuestion'
                    },
                    'CG00007':{
                        title:'开标参与人员登记（采购人）', // purchaseProjectCode purchaseSectionCode
                        queryMethod:'get',
                        path:'/cg/nonCustomForm/listBidOpenParticipantNode'
                    },
                    'CG00008':{
                        title:'开标参与人员登记（采购代理）', // purchaseProjectCode purchaseSectionCode
                        queryMethod:'get',
                        path:'/cg/nonCustomForm/listBidOpenParticipantNode'
                    },
                    'GC00007':{
                        title:'专家信息抽取申请',
                        queryMethod:'get',
                        path:'/nonCustomForm/formBuycommittee',
                    },
                    // 项目归档
                    'GC00050':{
                        title:'项目归档',
                        queryMethod:'get',
                        path:'/nonCustomForm/getTenderSummaryData',
                    },
                    // 招标文件及公告
                    'GC00004':{
                        title:'招标文件及公告',
                        queryMethod:'get',
                        path: `/businessFlow/flowNodeWitness/getEntityId`,
                    },
                },
                // 招标文件及公告
                fileNoticeList:['GC00004'],  //实际之前的招标文件  现在改成  招标文件及公告
                // 需要搜索过滤的列表集合  资审文件下载情况 招标文件下载情况 标书递交情况 保证金缴纳情况 资审申请文件递交情况
                filterFormList:['GC00014','GC00015','GC00016','GC00017','GC00034'],
                // 抽取列表
                extractingList:['GC00018'],
                // 澄清与答复
                clarificationAndReplyList:['GC00022','CG00027'],
                // 异议与答复
                objectionAndReplyList:['GC00030'],
                // 依法讯问
                askAndReplyList:['CG00036'],
                // 质疑管理
                quesManageListD:['CG00037'],
                // 评分情况
                scoreTableList:['GC00023','GC00036','CG00028'],
                // 采购项目
                purchaseProjectList:['CG00001'],
                // 开标参与人员登记
                openBidParticipantList:['CG00007','CG00008'],
                // 专家信息抽取申请
                expertExtractionList:['GC00007'],
                // 需要展示附件的节点集合
                showAttachmentList:['CG00001','GC00007'],
                //档案归档
                tenderSummaryCatalogList:['GC00050'],
                dataListLoading:false,
                userImg: require('@/assets/img/login/user.png'),
                documentImg: require('@/assets/img/login/user.png'),
                treeData:[],
                professorList:[],
                getScoreListParams:{
                    profCode:'',
                    supplierCode:'',
                },
                scoreTableData:[],
                customFormData:{
                    extractorName:"", // 抽取人姓名
                    extractTime:"",
                },
                attachmentList:[],
                auditHisTableCopy:[],
                groupList: [],
                formId:"",
                id:"",
                paramMap:{
                    // 招标项目编号
                    tenderProjectCode: '',
                    //datasetCode  数据集编码 查询见证数据所需参数
                    datasetCode:"",
                    // 标段编号
                    bidSectionCode: '',
                    // 项目编号
                    projectCode:'',
                    // 投标人
                    applyCode:"",
                },
                formInfo:{},
                pageSize:10,//每页条数
                pageIndex:1,//当前页
                total:0,//总条数
                form:{
                    keywords:"",
                    state:"99"
                },
                nodeCodeCopy:"",
                purchaseProjectInfo:{},
                tableData: [],
            }
        },
        activated() {

        },
        methods: {
            updateItem(index, filePath){
                const item = this.attachmentList[index]
                this.$set(this.attachmentList, index, { ...item, filePath: filePath})
            },
            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            fileDownload(filePath,fileName){
                if(filePath){
                    var a = document.createElement('a');
                    a.download = fileName;
                    a.target="_Blank";
                    a.href = filePath;
                    $("body").append(a);
                    a.click();
                    $(a).remove();
                }
            },
            getCatalogFn(params) {
                this.pageIndex = params.pageIndex;
                this.pageSize = params.pageSize;
                this.form.keywords = params.keywords;
                this.getCustomData()
            },

            // 查询附件
            getAttachments(entityId){

                let entityIdParam = entityId || this.entityId;
                if(!this.paramMap.categoryIsOpen){  // 不支持附件类别约束
                    this.$http.get(`/attachment/getAttachmentByBizId?bizid=${entityIdParam}`).then(({ data }) => {
                        if (data.code == "1") {
                            this.attachmentList = data.data || [];
                            this.attachmentList.forEach((item)=>{
                                item.titleName = '相关附件'
                            })
                        } else{
                            this.attachmentList = [];
                        }
                    });

                }else{

                    this.$http.get(`/attachment/getDataByCodeAndEid?categoryCode=${this.categoryCode}&entityId=${entityIdParam}`).then(({ data }) => {
                        if (data.code == "1") {
                            let resData= data.data;
                            if(resData && resData.length > 0){
                                resData.forEach(v => {
                                    v.titleName = v.name
                                })
                                this.attachmentList = resData;
                            }else{
                                this.attachmentList = [];
                            }
                        } else{
                            this.attachmentList = [];
                        }
                    });
                    // this.attachmentList =  [
                    //     {
                    //         "appId": "1d7358a453b14c0692860a04c561ebcc",
                    //         "attFiles": [
                    //             {
                    //                 "bizId": "03747cc69f0e400fbb2ef6cfb8d58240",
                    //                 "createDate": "2023-09-20 10:08:35",
                    //                 "delFlag": "1",
                    //                 "filePath": "/upload/eb5_jsgc_project_plan_att/7d3ba6d4b0d9b63d5ff8c4b4c190f79ccc4dc930e1ae95fc9af5c9505cd4ae92.pdf",
                    //                 "fileSize": 0,
                    //                 "fileType": "1",
                    //                 "hashCode": "",
                    //                 "id": "c0f6b1d380c3450196264288e3abd953",
                    //                 "name": "中标结果公告.pdf",
                    //                 "remark": "{comeform:GC}",
                    //                 "sort": 1,
                    //                 "updateDate": "2023-09-20 10:08:35"
                    //             },
                    //             {
                    //                 "bizId": "03747cc69f0e400fbb2ef6cfb8d58240",
                    //                 "createDate": "2023-09-20 10:08:35",
                    //                 "delFlag": "1",
                    //                 "filePath": "/upload/eb5_jsgc_project_plan_att/13b550b205a2e28e28976e8dc70bbc434982290b8ef44812dc2a90c0153bbcb3.pdf",
                    //                 "fileSize": 0,
                    //                 "fileType": "1",
                    //                 "hashCode": "",
                    //                 "id": "1a2ccde581b741e9890013da3217296f",
                    //                 "name": "测试 (1).pdf",
                    //                 "remark": "{comeform:GC}",
                    //                 "sort": 2,
                    //                 "updateDate": "2023-09-20 10:08:35"
                    //             }
                    //         ],
                    //         "attributes": {},
                    //         "categoryCode": "gc_project_plan_att",
                    //         "categoryId": "718f7d10bd204322bd07a2037c03e393",
                    //         "createTime": "2023-04-14 13:49:21",
                    //         "createUser": "system",
                    //         "delFlag": false,
                    //         "fileType": "1",
                    //         "id": "d60e6ff08f1f4d9585f25b85a4c34f57",
                    //         "titleName": "招标计划",
                    //         "required": false,
                    //         "showFlag": false,
                    //         "sort": 1,
                    //         "systemFlag": true,
                    //         "updateTime": "2023-08-15 18:52:03",
                    //         "updateUser": "system",
                    //         "upload": false,
                    //         "value": "1"
                    //     }
                    // ]
                }


            },

            getCustomDataFn(params){
                this.pageIndex = params.pageIndex;
                this.pageSize = params.pageSize;
                this.form.keywords = params.keywords;
                this.getCustomData()
            },
            getExpertExtractionFn(params){
                this.pageIndex = params.pageIndex;
                this.pageSize = params.pageSize;
                this.form.keywords = params.keywords;
                this.getCustomData()
            },
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1
                this.getCustomData()
            },
            currentChangeHandle (val) {
                this.pageIndex = val;
                this.getCustomData()
            },
            getScoreListFn(getScoreListParams,nodeCode){
                if(nodeCode == "GC00023" || nodeCode == "GC00036"){
                    this.$http.get(`/nonCustomForm/listGcEvalScoresDetail?tenderProjectCode=${this.paramMap.tenderProjectCode}&bidSectionCode=${this.paramMap.bidSectionCode}&profCode=${getScoreListParams.profCode}&supplierCode=${getScoreListParams.supplierCode}`).then(({ data }) => {
                        if (data.code == "1") {
                            this.scoreTableData = data.data;
                        } else{
                            this.scoreTableData = [];
                        }
                    });
                }
                if(nodeCode == "CG00028"){
                    this.$http.get(`/cg/nonCustomForm/listCgEvalScoresDetail?purchaseProjectCode=${this.paramMap.tenderProjectCode}&purchaseSectionCode=${this.paramMap.bidSectionCode}&profCode=${getScoreListParams.profCode}&supplierCode=${getScoreListParams.supplierCode}`).then(({ data }) => {
                        if (data.code == "1") {
                            this.scoreTableData = data.data;
                        } else{
                            this.scoreTableData = [];
                        }
                    });
                }

            },

            getCustomData(formId,paramMap,nodeCode,purchaserMode,getAuditHisByEntityId){
                // formId =自定义表单Id,paramMap= 项目数据参数 ，nodeCode = 节点编码，purchaserMode 采购方式 getAuditHisByEntityId = 是否通过查询 entityId参数，查询见证记录数据，
                this.formId = formId || this.formId;
                this.paramMap = paramMap || this.paramMap;
                this.nodeCodeCopy = nodeCode || this.nodeCodeCopy;
                nodeCode = nodeCode || this.nodeCodeCopy;
                // 节点切换会带此参数
                if(paramMap){
                    this.form.keywords = '';
                    this.form.state = '99';
                    this.pageSize = 10;
                    this.pageIndex = 1;
                    this.customFormData = {};
                    this.tableData = [];
                    this.treeData = [];
                    this.professorList = [];
                    this.scoreTableData = [];
                    this.getScoreListParams = {
                        profCode:'',
                        supplierCode:'',
                    }
                    this.total = 0;
                }
                if(nodeCode != ''){

                    let nodeCodeObj = this.nodeCodeMapper[nodeCode];
                    let getPath = '';
                    let queryPath = '';
                    const applyCode = this.paramMap.applyCode == '-1'?'':this.paramMap.applyCode;
                    const idcard = this.paramMap.idcard == '-1'?'':(this.paramMap.idcard || '');
                    let paramsData = {
                        tenderProjectCode:this.paramMap.tenderProjectCode, // 招标项目编码
                        bidSectionCode:this.paramMap.bidSectionCode, // 标段编码
                        code:this.paramMap.bidSectionCode,// 标段编码
                        datasetCode:this.paramMap.datasetCode,// 数据集编码 查询见证数据所需参数
                        purchaseProjectCode:this.paramMap.tenderProjectCode, // 采购项目编码
                        purchaseSectionCode:this.paramMap.bidSectionCode, // 采购包件编码
                        applyCode:applyCode, // 投标人
                        idcard:idcard, // 评委身份账号
                        keywords:this.form.keywords, // 搜索关键字
                        pageIndex:this.pageIndex,
                        pageSize:this.pageSize,
                        projectCode: this.projectCode
                    };
                    // 自定义表单定制化页面接口及参数处理
                    switch(nodeCode) {
                        //'资审文件下载情况' // dataType (1资审文件 2招标文件)
                        case 'GC00014':paramsData.dataType = '1';break;
                        //'招标文件下载情况' // dataType (1资审文件 2招标文件)
                        case 'GC00015':paramsData.dataType = '2';break;
                        //'资审申请文件递交情况' // dataType (1资审申请文件 2标书)  tenderProjectCode bidSectionCode keywords
                        case 'GC00034':paramsData.dataType = '1';break;
                        //'标书递交情况'  // dataType (1资审申请文件 2标书)  tenderProjectCode bidSectionCode keywords
                        case 'GC00016':paramsData.dataType = '2';break;
                        //'保证金缴纳情况' // dataType=0  tenderProjectCode bidSectionCode keywords
                        case 'GC00017':paramsData.dataType = '0'; paramsData.state=this.form.state == 99?'':this.form.state;break;
                        //'参数抽取情况' // tenderProjectCode bidSectionCode
                        case 'GC00018':break;
                        //'评委要求澄清与答复记录' // tenderProjectCode bidSectionCode
                        case 'GC00022':break;
                        //'异议与答复' // tenderProjectCode bidSectionCode keywords
                        case 'GC00030':break;
                        //'评委打分情况' // tenderProjectCode bidSectionCode
                        case 'GC00023':break;
                        //'招标人代理打分情况' // tenderProjectCode bidSectionCode
                        case 'GC00036':paramsData.type = '1';break;
                        // 采购-采购项目
                        case 'CG00001':break;
                        // 采购-评委要求澄清与答复记录
                        case 'CG00027':break;
                        // 采购-评委打分情况
                        case 'CG00028':break;
                        // 采购-依法询问
                        case 'CG00036':break;
                        // 采购-质疑管理
                        case 'CG00037':break;
                        //'开标参与人员登记 （采购人）' // tenderProjectCode bidSectionCode type = 1
                        case 'CG00007':paramsData.type = '1';break;
                        //'开标参与人员登记 （采购代理）' // tenderProjectCode bidSectionCode type = 2
                        case 'CG00008':paramsData.type = '2';break;
                        case 'GC00007': paramsData.thirdBusinessId =this.paramMap.thirdBusinessId; break;
                    }
                    queryPath = nodeCodeObj.queryMethod == 'get'?this.formatPath(nodeCodeObj.path,paramsData):nodeCodeObj.path;
                    if(queryPath != ''){
                        this.dataListLoading = true;
                        this.$http({
                            url: queryPath,
                            method: nodeCodeObj.queryMethod,
                            data: paramsData
                        }).then(({ data }) => {
                            this.dataListLoading = false;
                            if (data.code == "1") {
                                // 参数抽取情况 表单数据处理
                                if(nodeCode == "GC00018"){
                                    this.customFormData = data.data || {};
                                    this.tableData = (data.data && data.data.paramExtractDetails) || [];
                                    this.total = data.data.total;
                                    return
                                }
                                // 采购项目 表单数据处理
                                if(nodeCode == "CG00001"){
                                    this.purchaseProjectInfo = data.data || {};
                                    this.tableData = (data.data && data.data.bidSectionList) || [];
                                    return
                                }
                                // 开标参与人员登记 （采购人）和 '开标参与人员登记 （采购代理）'
                                if(nodeCode == "CG00007" || nodeCode == "CG00008"){
                                    this.tableData = data.data || [];
                                    let dataObj = this.tableData[0]?this.tableData[0]:'';
                                    this.$nextTick(()=>{
                                        this.$refs.openBidParticipantRef.getDetail(dataObj)
                                    })
                                    return
                                }
                                // 采购-依法询问
                                if(nodeCode == "CG00036"){
                                    this.purchaseProjectInfo = data.data || {};
                                    this.tableData = (data.data && data.data.pageList && data.data.pageList.rows) || [];
                                    this.total = ( data.data && data.data.pageList && data.data.pageList.total ) || 0;
                                    return
                                }
                                // 采购-质疑管理
                                if(nodeCode == "CG00037"){
                                    this.purchaseProjectInfo = data.data || {};
                                    this.tableData = (data.data && data.data.pageList && data.data.pageList.rows) || [];
                                    this.total = ( data.data && data.data.pageList && data.data.pageList.total ) || 0;
                                    return
                                }
                                // 专家抽取
                                if(nodeCode == "GC00007"){
                                    this.purchaseProjectInfo = data.data ||  {}
                                    return
                                }
                                // 项目归档
                                if(nodeCode == "GC00050"){
                                    this.purchaseProjectInfo = data.data ||  {}
                                    return
                                }

                                // '评委打分情况' '招标人代表打分情况' 采购-评委打分情况 表单数据处理
                                if( nodeCode == "GC00023" || nodeCode == "GC00036" || nodeCode == "CG00028" ){
                                    let bidderList = data.data.bidder || [];
                                    let professorList = data.data.professor || [];
                                    this.professorList = professorList;
                                    this.treeData = bidderList;
                                    if(professorList.length > 0 && bidderList.length > 0) {
                                        this.getScoreListParams.profCode = professorList[0].code || '';
                                        let firstLeafNodeCode = bidderList[0].code;
                                        this.getScoreListParams.supplierCode = firstLeafNodeCode || "";
                                        if(firstLeafNodeCode != ''){
                                            this.$nextTick(function() {
                                                this.$refs.scoreTableRef.setFirstNodeSelect(firstLeafNodeCode)
                                                this.getScoreListFn(this.getScoreListParams,nodeCode)
                                            })
                                        }
                                    }else{
                                        this.treeData = [];
                                        this.professorList = [];
                                        this.scoreTableData = [];
                                        this.getScoreListParams = {
                                            profCode:'',
                                            supplierCode:'',
                                        }
                                    }
                                    return
                                }
   
                                                                              // 招标文件及公告
                                if(this.nodeCodeCopy == "GC00004"){
                                    const dataObj = {
                                        entityId: data.data,
                                        bidSectionCode: this.paramMap.bidSectionCode,
                                        datasetCode: this.paramMap.datasetCode,
                                    }
                                    this.$nextTick(()=>{
                                        this.$refs.fileNoticeRef.getDetail(dataObj)
                                    })
                            
                                }

                                // 其他表单 表单数据处理
                                this.tableData = data.data.rows || [];
                                this.total = data.data.total || 0;

                            } else{
                                this.tableData = [];
                            }

                        });

                    }


                }else{

                    this.tableData = [];

                }

                if(getAuditHisByEntityId){
                    this.getEntityId()
                }else{
                    if(this.showAttachmentList.indexOf(this.nodeCodeCopy) > -1)this.getAttachments()
                }

            },
            formatPath(path,params){
                let pathStr = path + '?';
                for(var i in params){
                    let value = params[i];
                    pathStr += `&${i}=${value}`
                }
                return pathStr.replace('?&','?')
            },
            async getEntityId(){

                this.$http.get(`/businessFlow/flowNodeWitness/getEntityId?tenderProjectCode=${this.paramMap.tenderProjectCode}&bidSectionCode=${this.paramMap.bidSectionCode}&datasetCode=${this.paramMap.datasetCode}&projectCode=${this.projectCode}`).then(res=>{
                    if(res.data.code=='1'){
                        let responseId = res.data.data || '';


                        if(responseId){
                            if( this.fileNoticeList.indexOf(this.nodeCodeCopy) == -1  ) {
                                this.getAuditHisList(responseId)
                            }

                            if(this.showAttachmentList.indexOf(this.nodeCodeCopy) > -1){
                                this.getAttachments(responseId)
                            }

                        }else{
                            this.auditHisTableCopy = [];
                        }
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.msg
                        })
                    }
                })

            },
            // 获取见证记录
            async getAuditHisList(entityId){
                // 查询见证记录数据
                if(entityId){
                    this.$http.get('/auditHistory/getListAudit?entityId='+entityId).then(res=>{
                        if(res.data.code==='1'){
                            this.auditHisTableCopy = res.data.data;
                        }else{
                            this.auditHisTableCopy = [];
                            this.$message({
                                type:'error',
                                message:res.data.msg
                            })
                        }
                    })
                }else{
                    this.auditHisTableCopy = [];
                }

            },

            resetCustomData(){
                this.tableData = [];
                this.groupList = [];
                this.formInfo={}
            },



        }
    }
</script>


<style lang="less" scoped>


    .customFormWrapper{
        /deep/ .el-loading-mask{
            z-index: 100;
        }
    }

    .el-dialog__wrapper /deep/ .el-dialog__header{
    }
    .el-dialog__wrapper /deep/ .el-dialog__body{
        padding: 10px 20px;
    }
    .el-form{
        margin-bottom: 0px;
    }
    .el-dialog__wrapper /deep/ .el-dialog__footer{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .link:hover {
        cursor: pointer; //鼠标变手
        background-color: #0284fd; //链接变颜色
        color: white!important;
    }
</style>
